import { ComplexBase } from '@syncfusion/ej2-react-base';
/**
 * `ButtonDirective` represent a button of the react Toast.
 * It must be contained in a Toast component(`ToastrComponent`).
 * ```tsx
 * <ToastComponent>
 * <ButtonsDirective>
 * <ButtonDirective content='Ok' isPrimary=true></ButtonDirective>
 * <ButtonDirective content='Cancel'></ButtonDirective>
 * <ButtonsDirective>
 * </ToastComponent>
 * ```
 */
export class ButtonModelPropDirective extends ComplexBase {
}
ButtonModelPropDirective.moduleName = 'buttonModelProp';
export class ButtonModelPropsDirective extends ComplexBase {
}
ButtonModelPropsDirective.propertyName = 'buttons';
ButtonModelPropsDirective.moduleName = 'buttonModelProps';
